import { useMedia } from '@/common/service/hooks/useMedia';
import { CardsContainer } from '@/screens/HomePage/ui/CardsContainer';
import { BlogCard } from '@/entities/Blogs/ui/BlogCard';
import { memo } from 'react';
import URL from '@/common/app/utils/urlsUtils';
import { BlogsListProps } from './BlogsDetailPage.types';

const BlogsListContainer = ({ destinationName, blogs }: BlogsListProps) => {
    const isMobileView = useMedia('(max-width: 991px)');

    return (
        <CardsContainer
            title={`${destinationName} News`}
            linkName="View More Blogs"
            linkHref="/blog"
            description="Keeping you informed"
        >
            {blogs.items.slice(0, isMobileView ? 2 : 6).map((blog) => {
                return (
                    <BlogCard
                        cardLink={`/blog/${blog.slug}/`}
                        imageSrc={`${URL.image}/blog/${blog.image.id}/1000x460/${blog.image.slug}.jpg`}
                        date={blog.updated_at}
                        title={blog.title}
                        location={blog.category.name}
                        key={blog.slug}
                    />
                );
            })}
        </CardsContainer>
    );
};

const BlogsList = memo(BlogsListContainer);

export { BlogsList };
